import { createFileRoute } from "@tanstack/react-router";
import AdminIPUniversities from "@/pages/AdminIPUniversities";
import RoleGate from "@/components/auth/RoleGate";

export const Route = createFileRoute("/admin/ip-library/universities/")({
  component: () => (
    <RoleGate allow={['staff']} area="IP Library"><AdminIPUniversities /></RoleGate>
  ),
});
